import React from "react";
import { Link } from "gatsby";

import * as buttonStyles from "./Button.module.css";

const Button = (props) => {
  const {
    type,
    children,
    destination,
    to,
    variant,
    // isLink,
    onClick,
    disabled,
    opensInNewWindow,
    styleAsButton,
  } = props;

  return type !== "submit" ? (
    <Link
      to={destination || to}
      target={opensInNewWindow ? "_blank" : null}
      rel={opensInNewWindow ? "noreferrer" : null}
      className={`${buttonStyles.button} ${
        !styleAsButton && buttonStyles.link
      } ${buttonStyles[variant]}`}
    >
      {children}
    </Link>
  ) : (
    <button
      onClick={onClick}
      className={`${buttonStyles.button} ${buttonStyles[variant]}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
